// extracted by mini-css-extract-plugin
export default {"bottom":"AuthBottom_bottom__+SVnv","wrapper":"AuthBottom_wrapper__yhDO4","block":"AuthBottom_block__J6DxS","repeat":"AuthBottom_repeat__Qukv5"};